module.exports = __webpack_public_path__ + "img/special.857b804.svg";